import { forwardRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box, { BoxProps } from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const theme = useTheme();

    const PRIMARY_LIGHT = theme.palette.primary.light;

    const PRIMARY_MAIN = theme.palette.primary.main;

    const PRIMARY_DARK = theme.palette.primary.dark;

    // OR using local (public folder)
    // -------------------------------------------------------
    // const logo = (
    //   <Box
    //     component="img"
    //     src="/logo/logo_single.svg"
    //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
    //   />
    // );

    const logo = (
      <Box
        ref={ref}
        component="div"
        sx={{
          width: 40,
          height: 40,
          pt: 2,
          ...sx,
        }}
        {...other}
      >
        <svg
          width="196"
          height="50"
          viewBox="0 0 197 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M68.3913 31.3319C66.4343 15.9173 53.2698 4 37.3235 4C21.3773 4 8.21276 15.9173 6.25289 31.3319C6.08621 32.6395 6 33.97 6 35.3206C6 35.9787 6.02012 36.6339 6.06035 37.2805C6.32186 41.5279 7.48571 45.6315 9.27316 49.2524C9.96573 50.7324 11.2733 51.6951 12.8998 51.6951C13.9487 51.6951 14.8999 51.2727 15.5953 50.5916C15.7505 50.4393 15.8942 50.2726 16.0207 50.0944L18.8398 55.9568L19.7479 57.8448H36.8292C35.4671 56.3534 33.7745 55.1665 31.8663 54.3964L32.5129 51.4307H42.6112L43.2348 54.4452C41.3783 55.2154 39.7288 56.385 38.3954 57.842H55.563L56.132 56.6551L56.4481 55.9999L59.2299 50.7525C59.9052 51.3359 60.7845 51.6893 61.7444 51.6893C63.3709 51.6893 64.6813 50.7238 65.371 49.2467C67.1584 45.6258 68.3194 41.5221 68.5838 37.2748C68.624 36.6282 68.6442 35.973 68.6442 35.3149C68.6442 33.9643 68.5579 32.6308 68.3913 31.3262V31.3319Z"
            fill="#FFC500"
          />
          <path
            d="M48.4506 53.4165C46.6028 53.4165 44.8383 53.7843 43.2319 54.451C41.3755 55.2212 39.726 56.3908 38.3926 57.8478H55.5602L56.4453 56.0057"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M48.4506 53.4165C46.6028 53.4165 44.8383 53.7843 43.2319 54.451C41.3755 55.2212 39.726 56.3908 38.3926 57.8478H55.5602L56.4453 56.0057"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M45.051 50.8473C43.14 51.2094 41.1801 51.4393 39.1858 51.5255C39.1513 51.5255 39.1197 51.5284 39.0852 51.5312C38.5823 51.5514 38.0765 51.5657 37.5679 51.5686H37.5478C37.473 51.5686 37.3983 51.5686 37.3207 51.5686C35.6942 51.5686 34.0878 51.4738 32.5073 51.2898C31.2773 51.1462 30.0646 50.9508 28.8691 50.7036"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M65.371 49.2553C64.6785 50.7353 63.3709 51.6979 61.7444 51.6979C60.6955 51.6979 59.7443 51.2755 59.0488 50.5944C58.3362 49.8961 57.8965 48.9248 57.8965 47.8472"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M57.6521 46.2351C57.8102 46.6575 57.8964 47.1116 57.8964 47.5886C57.8964 49.7152 56.1722 51.4394 54.0456 51.4394C52.5656 51.4394 51.2811 50.606 50.6374 49.3789C50.3558 48.8444 50.1948 48.2381 50.1948 47.5915C50.1948 46.5742 50.5856 45.6575 51.2236 44.9678"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M54.3588 27.0042C54.6462 28.0847 54.8014 29.2227 54.8014 30.3951C54.8014 34.9816 52.4507 39.091 48.8901 41.4417C48.7177 41.5538 48.5539 41.6831 48.416 41.8354C48.0625 42.2234 47.8125 42.7521 47.8125 43.2895C47.8125 44.4591 48.7608 45.4074 49.9304 45.4074C51.1 45.4074 52.0484 44.4591 52.0484 43.2895"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M56.4482 56.0057L55.5631 57.8478H38.3955C39.7289 56.3879 41.3784 55.2212 43.2348 54.451C44.8413 53.7843 46.6028 53.4165 48.4535 53.4165"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M26.7713 53.4165C28.5731 53.4165 30.2916 53.7671 31.8664 54.4022C33.7746 55.1695 35.4672 56.3563 36.8293 57.8506H19.7479L18.8398 55.9626"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M38.3955 57.8506H55.5602L56.4482 56.0057L59.0489 50.5945"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M36.8291 57.8505H19.7478L18.8397 55.9596L15.9976 50.0483"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M42.5767 51.2783L43.2462 54.5055"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M31.8433 54.5055L31.8663 54.402L32.5071 51.2927L32.5128 51.2783"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M68.5838 37.2834C68.624 36.6368 68.6442 35.9816 68.6442 35.3235C68.6442 18.0237 54.6204 4 37.3235 4C20.0266 4 6 18.0237 6 35.3235C6 35.9816 6.02012 36.6368 6.06035 37.2834C6.32186 41.5307 7.48571 45.6315 9.27316 49.2553C9.96573 50.7353 11.2733 51.698 12.8998 51.698C13.9487 51.698 14.8999 51.2755 15.5953 50.5945C16.308 49.8961 16.7477 48.9248 16.7477 47.8472"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M6.06035 37.2834C6.02012 36.6368 6 35.9816 6 35.3235C6 18.0237 20.0237 4 37.3235 4C54.6233 4 68.6442 18.0237 68.6442 35.3206C68.6442 35.9787 68.624 36.6339 68.5838 37.2805C68.3223 41.5279 67.1584 45.6287 65.371 49.2524C64.6784 50.7324 63.3709 51.6951 61.7444 51.6951C60.6955 51.6951 59.7443 51.2726 59.0488 50.5916C58.3361 49.8933 57.8965 48.9219 57.8965 47.8443"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M16.9918 46.2351C16.8338 46.6575 16.7476 47.1116 16.7476 47.5886C16.7476 49.7152 18.4718 51.4394 20.5983 51.4394C22.0783 51.4394 23.3629 50.606 24.0066 49.3789C24.2882 48.8444 24.4491 48.2381 24.4491 47.5915C24.4491 46.5742 24.0583 45.6575 23.4203 44.9678"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M20.2853 27.0042C19.998 28.0847 19.8428 29.2227 19.8428 30.3951C19.8428 34.9816 22.1935 39.091 25.754 41.4417C25.9264 41.5538 26.0902 41.6831 26.2282 41.8354C26.5816 42.2234 26.8317 42.7521 26.8317 43.2895C26.8317 44.4591 25.8833 45.4074 24.7137 45.4074C23.5441 45.4074 22.5958 44.4591 22.5958 43.2895"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M27.2222 22.8085C29.2137 26.2483 32.9351 28.5645 37.194 28.5645C41.6425 28.5645 45.499 26.0443 47.4187 22.3516"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M45.2467 17.6989C45.2467 17.6989 42.0109 15.7764 38.7837 17.6989"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M35.8609 17.6989C35.8609 17.6989 32.6251 15.7764 29.3979 17.6989"
            stroke="black"
            stroke-width="0.4483"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M89.3792 31.6457H95.1122V38.9076C95.1122 41.0916 94.6936 42.857 93.8564 44.2039C93.0192 45.5507 91.8908 46.5335 90.4712 47.1523C89.088 47.7711 87.5045 48.0805 85.7209 48.0805C83.7189 48.0805 82.1719 47.8075 81.0799 47.2615C80.0243 46.7155 79.4965 45.9147 79.4965 44.8591C79.4965 44.2767 79.6057 43.7853 79.8241 43.3848C80.0425 42.9844 80.2609 42.675 80.4793 42.4566C81.0617 42.675 81.6987 42.8752 82.3903 43.0572C83.1183 43.2392 83.8463 43.3302 84.5743 43.3302C86.1759 43.3302 87.3771 42.948 88.1779 42.1836C88.9788 41.3828 89.3792 40.127 89.3792 38.4162V31.6457ZM95.1122 33.6659H89.3792V14.2827C89.634 14.2099 89.998 14.1371 90.4712 14.0643C90.9808 13.9551 91.4904 13.9005 92 13.9005C93.0556 13.9005 93.8382 14.1007 94.3478 14.5011C94.8574 14.8651 95.1122 15.5385 95.1122 16.5213V33.6659ZM127.796 34.6487C127.796 37.3788 127.268 39.763 126.213 41.8014C125.157 43.8399 123.665 45.4233 121.736 46.5517C119.806 47.6437 117.531 48.1897 114.91 48.1897C112.29 48.1897 110.015 47.6437 108.085 46.5517C106.156 45.4233 104.664 43.8581 103.608 41.856C102.553 39.8176 102.025 37.4152 102.025 34.6487C102.025 31.8823 102.553 29.4981 103.608 27.4961C104.7 25.4576 106.211 23.8924 108.14 22.8004C110.106 21.672 112.362 21.1078 114.91 21.1078C117.495 21.1078 119.752 21.672 121.681 22.8004C123.61 23.8924 125.103 25.4576 126.158 27.4961C127.25 29.4981 127.796 31.8823 127.796 34.6487ZM114.91 25.6396C112.726 25.6396 110.979 26.4405 109.669 28.0421C108.395 29.6437 107.758 31.8459 107.758 34.6487C107.758 37.488 108.377 39.7084 109.614 41.31C110.888 42.8752 112.654 43.6578 114.91 43.6578C117.167 43.6578 118.915 42.857 120.152 41.2554C121.426 39.6538 122.063 37.4516 122.063 34.6487C122.063 31.8459 121.426 29.6437 120.152 28.0421C118.878 26.4405 117.131 25.6396 114.91 25.6396ZM156.874 30.6629V36.0684H151.25V30.8813C151.25 29.0613 150.74 27.7327 149.721 26.8955C148.702 26.0582 147.337 25.6396 145.626 25.6396C144.352 25.6396 143.205 25.8034 142.186 26.1311C141.167 26.4587 140.293 26.8227 139.565 27.2231V36.0684H133.941V27.1139C133.941 26.2767 134.105 25.6032 134.433 25.0936C134.797 24.5476 135.361 24.038 136.125 23.5648C137.145 22.946 138.473 22.3818 140.111 21.8722C141.749 21.3626 143.587 21.1078 145.626 21.1078C149.157 21.1078 151.905 21.9086 153.871 23.5102C155.873 25.0754 156.874 27.4597 156.874 30.6629ZM133.941 33.2291H139.565V47.3161C139.31 47.3889 138.946 47.4799 138.473 47.5891C138.036 47.6983 137.545 47.7529 136.999 47.7529C135.98 47.7529 135.215 47.5527 134.706 47.1523C134.196 46.7519 133.941 46.0967 133.941 45.1867V33.2291ZM151.25 33.2291H156.874V47.3161C156.619 47.3889 156.255 47.4799 155.782 47.5891C155.308 47.6983 154.817 47.7529 154.307 47.7529C153.252 47.7529 152.469 47.5527 151.96 47.1523C151.486 46.7519 151.25 46.0967 151.25 45.1867V33.2291ZM173.997 43.8217C175.308 43.8217 176.418 43.6943 177.328 43.4394C178.274 43.1482 178.966 42.8752 179.403 42.6204V35.577L173.342 36.1776C171.668 36.3232 170.394 36.7054 169.52 37.3242C168.683 37.9066 168.264 38.7802 168.264 39.945C168.264 41.1462 168.737 42.0926 169.684 42.7842C170.63 43.4758 172.068 43.8217 173.997 43.8217ZM173.834 21.1078C177.219 21.1078 179.894 21.854 181.86 23.3464C183.862 24.8024 184.863 27.1139 184.863 30.2807V43.0026C184.863 43.8399 184.681 44.4951 184.317 44.9683C183.953 45.4415 183.443 45.8601 182.788 46.2241C181.842 46.7701 180.604 47.2251 179.075 47.5891C177.583 47.9895 175.89 48.1897 173.997 48.1897C170.466 48.1897 167.7 47.5163 165.698 46.1695C163.732 44.7863 162.75 42.766 162.75 40.1088C162.75 37.7064 163.532 35.8682 165.097 34.5941C166.663 33.2837 168.883 32.5011 171.759 32.2463L179.403 31.4819V30.2261C179.403 28.5881 178.875 27.4051 177.819 26.6771C176.764 25.949 175.326 25.585 173.506 25.585C172.05 25.585 170.63 25.7852 169.247 26.1857C167.9 26.5861 166.699 27.0411 165.643 27.5507C165.316 27.2595 165.025 26.9137 164.77 26.5133C164.515 26.0764 164.388 25.6214 164.388 25.1482C164.388 24.0198 165.006 23.1644 166.244 22.582C167.263 22.1088 168.428 21.7448 169.738 21.49C171.085 21.2352 172.45 21.1078 173.834 21.1078Z"
            fill="black"
          />
        </svg>
      </Box>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

export default Logo;
